/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import {
  Button,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
} from '@material-ui/core';

import moment from 'moment';
import { useHistory, useLocation, useParams } from 'react-router';
import { isEmpty } from 'lodash';
import Input from '../../../components/Input';
import CustomCheckbox from '../../../components/Checkbox';
import Snackbar, { AlertComponentProps } from '../../../components/Snackbar';
import { useAxios } from '../../../utils/hooks';
import { Form as FormModel } from '../../../models/form';
import getValidationErrors from '../../../utils/getValidationErrors';
import Loader from '../../../components/Loader';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    background: 'white',
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  formTitles: {
    fontWeight: 'bolder',
  },
  formControl: {
    margin: theme.spacing(2, 0),
  },
  divider: {
    margin: theme.spacing(2),
  },
}));

const AdoptionForm: React.FC = () => {
  const api = useAxios();
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState<FormModel | null>(null);
  const { formId } = useParams<{ id: string; formId: string }>();

  const formRef = useRef<FormHandles>(null);

  const [alert, setAlert] = useState<
    AlertComponentProps & { isActive: boolean }
  >({
    isActive: false,
    type: 'info',
    message: 'none',
  });

  useEffect(() => {
    async function getInitFormData() {
      try {
        const formResponse = await api.current?.get(`/forms/${formId}`);

        setForm(formResponse?.data);
      } catch (error) {
        setAlert({
          isActive: true,
          type: 'error',
          message: 'Erro ao carregar formulário.',
        });
      } finally {
        setLoading(false);
      }
    }

    getInitFormData();
  }, [api, formId]);

  return (
    <>
      <Loader loading={loading} />

      {!loading && (
        <Form
          id="form"
          ref={formRef}
          initialData={form?.answers}
          onSubmit={() => console.log('submit')}
          className={classes.root}
        >
          <FormControl fullWidth className={classes.formControl}>
            <Typography
              variant="h5"
              component="h1"
              align="center"
              className={classes.formTitles}
            >
              FICHA DE CONTATO INICIAL - PACIENTES MINISTÉRIO PÚBLICO (MP)
            </Typography>

            <Typography
              variant="h6"
              component="h6"
              align="center"
              className={classes.formTitles}
            >
              (preenchida pelo paciente ou responsável)
            </Typography>

            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <FormLabel className={classes.formTitles}>
              DADOS DE IDENTIFICAÇÃO
            </FormLabel>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  1 - DO PACIENTE:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  id="patient_name"
                  disabled
                  label="Nome"
                  name="patient_name"
                />
              </Grid>

              {/* <Grid item xs={6}>
                <Input id="patient_rg" disabled label="RG" name="patient_rg" />
              </Grid> */}

              {/* TODO: 'cpf-cnpj-validator' */}

              <Grid item xs={6}>
                <Input
                  id="patient_cpf"
                  disabled
                  label="CPF"
                  name="patient_cpf"
                />
              </Grid>

              <Grid item xs={2}>
                <Input
                  id="patient_age"
                  disabled
                  label="Idade"
                  name="patient_age"
                />
              </Grid>

              <Grid item xs={5}>
                <Input
                  disabled
                  id="patient_gender"
                  label="Gênero"
                  name="patient_gender"
                />
              </Grid>

              <Grid item xs={5}>
                <Input
                  disabled
                  id="patient_birth"
                  label="Data de Nascimento"
                  name="patient_birth"
                  placeholder="23/02/1997"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="patient_birth_local"
                  label="Naturalidade"
                  name="patient_birth_local"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="patient_religion"
                  label="Religião"
                  name="patient_religion"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  INSTITUIÇÃO:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="address_street"
                  label="Logradouro"
                  name="address_street"
                  placeholder="Rua/Av./Denominação/número/complemento"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="address_neighborhood"
                  label="Bairro"
                  name="address_neighborhood"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  id="address_city"
                  disabled
                  label="Cidade"
                  name="address_city"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="address_zipcode"
                  label="CEP"
                  name="address_zipcode"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="address_phones"
                  label="Telefones"
                  name="address_phones"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="address_responsible"
                  label="Responsável Técnico"
                  name="address_responsible"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="address_parents"
                  label="Pais Sociais"
                  name="address_parents"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="address_date"
                  label="Data do Abrigamento"
                  name="address_date"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  ESCOLARIDADE:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="school_name"
                  label="Nome da Escola"
                  name="school_name"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="school_address"
                  label="Endereço"
                  name="school_address"
                />
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="school_phones"
                  label="Telefones"
                  name="school_phones"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="school_year"
                  disabled
                  label="Série"
                  name="school_year"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="school_period"
                  disabled
                  label="Turno"
                  name="school_period"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  disabled
                  id="school_fails"
                  label="Número de repetências"
                  name="school_fails"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="school_teacher"
                  label="Nome da professora"
                  name="school_teacher"
                />
              </Grid>

              <Grid item xs={6}>
                <Input
                  disabled
                  id="school_coordinator"
                  label="Nome da orientadora"
                  name="school_coordinator"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  MOTIVO DA PROCURA AO CEAPIA:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="motive"
                  label="Descreva resumidamente qual é e quando começou o problema que o traz ao CEAPIA"
                  name="motive"
                  isMultiline
                  rows={5}
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  DADOS DA FAMÍLIA BIOLÓGICA:
                </FormLabel>
              </Grid>

              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Nome dos pais:
                </FormLabel>
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="mother_name"
                  disabled
                  label="Mãe"
                  name="mother_name"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="mother_age"
                  disabled
                  label="Idade"
                  name="mother_age"
                />
              </Grid>

              <Grid item xs={8}>
                <Input
                  id="father_name"
                  disabled
                  label="Pai"
                  name="father_name"
                />
              </Grid>

              <Grid item xs={4}>
                <Input
                  id="father_age"
                  disabled
                  label="Idade"
                  name="father_age"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  SITUAÇÃO JURÍDICA DO PACIENTE:
                </FormLabel>
              </Grid>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Destituído do Poder Familiar
                </FormLabel>
                disabled
                <Input id="destituido" label="Quando?" name="destituido" />
              </Grid>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Em processo de destituição
                </FormLabel>

                <Input
                  disabled
                  id="destituido_in_progress"
                  label="Outros:"
                  name="destituido_in_progress"
                />
              </Grid>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  Apadrinhamento Afetivo
                </FormLabel>

                <Input
                  disabled
                  id="apadrinhamento"
                  label="Nome e contato:"
                  name="apadrinhamento"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  RELAÇÃO DE TODAS AS PESSOAS QUE RESIDEM NA INSTITUIÇÃO:
                </FormLabel>
              </Grid>

              {/* 1) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_1_name"
                  label="Nome"
                  name="resident_1_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_1_age"
                  label="Idade"
                  name="resident_1_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_1_parent"
                  label="Parentesco"
                  name="resident_1_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_1_ocupation"
                  label="Ocupação"
                  name="resident_1_ocupation"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              {/* 2) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_2_name"
                  label="Nome"
                  name="resident_2_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_2_age"
                  label="Idade"
                  name="resident_2_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_2_parent"
                  label="Parentesco"
                  name="resident_2_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_2_ocupation"
                  label="Ocupação"
                  name="resident_2_ocupation"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              {/* 3) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_3_name"
                  label="Nome"
                  name="resident_3_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_3_age"
                  label="Idade"
                  name="resident_3_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_3_parent"
                  label="Parentesco"
                  name="resident_3_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_3_ocupation"
                  label="Ocupação"
                  name="resident_3_ocupation"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              {/* 4) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_4_name"
                  label="Nome"
                  name="resident_4_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_4_age"
                  label="Idade"
                  name="resident_4_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_4_parent"
                  label="Parentesco"
                  name="resident_4_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_4_ocupation"
                  label="Ocupação"
                  name="resident_4_ocupation"
                />
              </Grid>

              <FormControl fullWidth className={classes.formControl}>
                <Divider className={classes.divider} />
              </FormControl>

              {/* 5) */}
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_5_name"
                  label="Nome"
                  name="resident_5_name"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_5_age"
                  label="Idade"
                  name="resident_5_age"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_5_parent"
                  label="Parentesco"
                  name="resident_5_parent"
                />
              </Grid>
              <Grid item xs={6}>
                <Input
                  disabled
                  id="resident_5_ocupation"
                  label="Ocupação"
                  name="resident_5_ocupation"
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormLabel className={classes.formTitles}>
                  TERMO DE AUTORIZAÇÃO:
                </FormLabel>
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                Eu
                <Input
                  disabled
                  id="term_responsible_name"
                  label="Nome do responsável"
                  name="term_responsible_name"
                />
              </Grid>

              <Grid item xs={12}>
                estou ciente de que o CEAPIA é uma Instituição que visa o
                ensino, o atendimento e a pesquisa na infância e na adolescência
                e autorizo que os dados referentes ao atendimento da
                criança/adolescente
              </Grid>

              <Grid item xs={12}>
                <Input
                  disabled
                  id="term_responsible_for"
                  label="Nome da criança / adolescente"
                  name="term_responsible_for"
                />
              </Grid>

              <Grid item xs={12}>
                possam vir a serem utilizados na Instituição para fins de
                pesquisa.
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                O CEAPIA compromete-se a manter sob restrito sigilo profissional
                as informações obtidas nos atendimentos.
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div onClick={() => console.log('agree')}>
                  <CustomCheckbox
                    name="agree"
                    disabled
                    value="agree"
                    label=" Declaro que li e estou de acordo com as informações deste termo."
                  />
                </div>
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                Diretora de Atendimento
              </Grid>

              <Grid item xs={6}>
                Assinatura do responsável
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={2} justify="flex-end">
              <Grid item xs={2}>
                <Input
                  disabled
                  id="form_data"
                  label="Data"
                  name="form_data"
                  defaultValue={moment().format('DD/MM/YYYY').toString()}
                />
              </Grid>
            </Grid>
          </FormControl>

          <FormControl fullWidth className={classes.formControl}>
            <Divider className={classes.divider} />
          </FormControl>

          <FormControl fullWidth className={classes.formTitles}>
            <Grid container spacing={1} justify="center">
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => history.goBack()}
                >
                  Voltar
                </Button>
              </Grid>
            </Grid>
          </FormControl>
        </Form>
      )}

      {alert.isActive && <Snackbar {...alert} />}
    </>
  );
};

export default AdoptionForm;
